/** 言語ごとの辞書の読み込み。辞書は言語ごとの遅延チャンクにして、使わない言語を配信に含めない（docs/I18N.md・ADR 0031） */
import type { LanguageId } from '../languages';
import type { Dictionary } from './dictionary';

export const DICTIONARY_LOADERS: Record<LanguageId, () => Promise<{ DICTIONARY: Dictionary }>> = {
  ja: () => import('./ja'),
  en: () => import('./en'),
  'zh-CN': () => import('./zh-CN'),
  ko: () => import('./ko'),
  es: () => import('./es'),
  fr: () => import('./fr'),
  de: () => import('./de'),
  'pt-BR': () => import('./pt-BR'),
};
